import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatOption, MatSelect, MatSelectChange} from "@angular/material/select";
import {
  DefectDialogData,
  ProductCardDefect,
  ProductCardDefectValue,
  UpdateFeedbackDefectsParams
} from "./types/defects-modal.types";
import {DefectsModalService} from "./services/defects-modal.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {FormsModule} from "@angular/forms";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatDivider} from "@angular/material/divider";
import {defectsModalName} from "./configs/defects-modal-config";

@Component({
  selector: 'app-defects-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatSelect,
    MatOption,
    FormsModule,
    MatLabel,
    MatCheckbox,
    MatDivider
  ],
  templateUrl: './defects-modal.component.html',
  styleUrl: './defects-modal.component.scss'
})
export class DefectsModalComponent extends BaseModalComponent {
  private defectDialogData = inject<DefectDialogData>(MAT_DIALOG_DATA);
  private defectsModalService: DefectsModalService = inject(DefectsModalService);

  public defects: Array<ProductCardDefect> = [];
  public defectValues: Array<ProductCardDefectValue> = [];
  public selectedDefectValues: Array<number> = [];
  public selectedDefect: number | null = null;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(defectsModalName);
    await this.getDefects();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(defectsModalName);
  }

  public async getDefectValues(event: MatSelectChange): Promise<void> {
    const queryParams = this.defectsModalService.getDefectQueryParams({
      productCardDefectId: event.value
    });

    this.defectValues = await this.defectsModalService.getProductCardsDefectValues(queryParams).catch(() => [])
  }

  public async handleSave(): Promise<void> {
    const updateFeedbackDefectsParams: UpdateFeedbackDefectsParams = {
      id: Number(this.defectDialogData.recordData.id),
      feedbackDefects: {
        productCardDefectId: this.selectedDefect,
        productCardDefectValueIds: this.selectedDefectValues
      }
    };

    await this.defectsModalService.updateFeedbackDefects(updateFeedbackDefectsParams)
      .finally(() => this.closeDialog('cancel'));
  }

  public isAllSelected(): boolean {
    return this.selectedDefectValues.length === this.defectValues.length;
  }

  public toggleSelectAll(): void {
    this.selectedDefectValues = this.isAllSelected() ?
      [] :
      this.defectValues.map(option => option.id);
  }

  private async getDefects(): Promise<void> {
    const queryParams = this.defectsModalService.getDefectQueryParams({
      productCardId: this.defectDialogData.productCardId
    });

    this.defects = await this.defectsModalService.getProductCardsDefects(queryParams).catch(() => []);
  }
}
